import React from 'react'
import Skeleton from '@mui/material/Skeleton';
import { Grid, Typography, Avatar, Box, Card, CardHeader, CardContent } from '@mui/material';

const MyAccountLoading = () => {
    const skeletonStyles = {
        backgroundColor: "white",
        color: "white", // Set the text color to white
      };

    return (
        <Card>
          <CardHeader
            sx={{
              textAlign: "center",
              fontWeight: "bold",
            }}
            title={
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                  className="text-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Avatar className="avatar" alt="User Avatar">
                    <Skeleton variant="circular" width={50} height={50}  sx={{ ...skeletonStyles }}/>
                  </Avatar>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={8}
                  className="text-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                    <Skeleton variant="text" width={150} sx={{ ...skeletonStyles }} />
                </Grid>
              </Grid>
            }
          />
    
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={8}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className="inline"
                  sx={{
                    fontWeight: "600",
                  }}
                >
                  <Skeleton variant="text" width={100}  sx={{ ...skeletonStyles }} />
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  className="inline"
                  sx={
                    {
                      // display: "inline-block",
                    }
                  }
                >
                  <Skeleton variant="text" width={100} sx={{ ...skeletonStyles }} />
                </Typography>
              </Grid>
    
            </Grid>
            <Box className="mt-6 text-center">
              <Skeleton variant="rectangular" width={150} height={40}  sx={{ ...skeletonStyles }} />
            </Box>
          </CardContent>
        </Card>
      );
}

export default MyAccountLoading